<template>
    <div class="inspectView" v-loading="dataLoading">
        <!--列表详情页面-->
        <div class="detailBox" v-if="isShowDetail">
            <div class="detailBoxTop">
                <div @click="closeDetil" class="topNavClose">×</div>
            </div>
            <detailView :sendData="sendData" />
        </div>
        <div class="inspectTop">
            <div class="inspectTopLeft">最新稽查案例</div>
            <div class="inspectTopRight" @click="refreshData">
                <img :src="imgObj.shua" alt="">
                换一换
            </div>
        </div>
        <div class="dataListBox">
            <div class="dataList" 
                v-for="(item,index) in dataList" 
                :key="index"
                @click="dataListClick(item,index)">
                <span class="listIndex">{{ index + 1 }}.</span>
                <span>{{ item.title }}</span>
            </div>
        </div>  
    </div>
</template>
<script>
//图片
import shua from '@/assets/images/icon/shua.png'

//接口
import { newInspectData } from '@/api/api.js'

//引入組件
import detailView from "./detail.vue"

export default {
    name:'',
    components:{
        detailView
    },
    data(){
        return{
            imgObj:{
                shua
            },
            dataLoading:false,
            //数据列表
            dataList:[],
            //详情的参数
            sendData:{
                id:'',
            },
            //是否列表详情页面
            isShowDetail:false,
        }
    },
    created(){

    },
    mounted(){
        this.getData();
    },
    methods:{
        //请求列表
        getData(){
            this.dataLoading = true;
            let data = {
                categoryId: 33500,
                page: 1,
                size: 6,
                sortType:"random"
            }
            newInspectData(data).then(res => {
                //console.log(res)
                if(res.status == 200&& res.data.status == 0){
                    //过滤文字
                    let tRes = res.data.data.contents;
                    tRes.forEach(item => {
                        //console.log(item)
                        let newTitle = item.title.replace('税干学税法：', '').replace('老板看税收：', '')
                        item.title = newTitle
                    });

                    this.dataList = tRes;
                    this.dataLoading = false;
                }
            }).catch(err => {
                console.log(err)
                this.dataLoading = false;
            })
        },
        //刷新列表 换一换
        refreshData(){
            this.getData();
        },
        //列表点击
        dataListClick(item,index){
            //console.log(this.$store.state)
            //判断登录
            if(!this.$store.state.user.id){
                this.$message({
                    message:'请登录后查看',
                    type:'warning'
                })
                return
            }   
            //详情参数
            this.sendData.id = item.id;
            //展示
            this.isShowDetail = true;
            return
            //展开详情
            let Detail = this.$router.resolve({
            path: '/content',
                query: {
                    contentId: item.id,
                    keyWord: '',
                    searchType: 1,
                    tagIds: 32500,
                },
            })
            window.open(Detail.href, '_blank')
        },
        //关闭详情
        closeDetil(){
            //清除详情参数
            this.sendData.id = '';
            //关闭详情展示
            this.isShowDetail = false;
        }
    }
}
</script>

<style scoped lang="scss">
.inspectView{
    width:100%;
    /*overflow: hidden;*/
    margin-top:10px;
    position: relative;
    .detailBox{
        width:100%;
        position: absolute;
        height:610px;
        overflow:hidden ;
        z-index:999;
        background: #ffffff;
        .detailBoxTop{
            width:100%;
            height:40px;
            .topNavClose{
                width: 30px;
                height: 30px;
                background: #0F59A4;
                border-radius: 50%;
                position: absolute;
                right: 18px;
                top: 5px;
                color: #ffffff;
                font-size: 30px;
                text-align: center;
                line-height: 26px;
                cursor: pointer;
            }
        }
    }
    .inspectTop{
        width:100%;
        height: 44px;
        box-sizing: border-box;
        padding:10px 0;
        .inspectTopLeft{
            width:120px;
            height: 24px;
            float:left;
            font-weight: 700;
            font-size: 18px;
            color: #0F59A4;
        }
        .inspectTopRight{
            width:80px;
            height:20px;
            float:right;
            color:#0F59A4;
            cursor:pointer;
            text-align: center;
            img{
                width:16px;
                height:14px;
                margin-right:2px;
                position: relative;
            }
        }
    }
    .dataListBox{
        width:100%;
        overflow: hidden;
        .dataList{
            width: 100%;
            height:30px;
            line-height: 30px;
            color:#3D3D3D;
            font-size:16px;
            cursor:pointer;
            .listIndex{
                color:#0F59A4;
            }
        }
    }
}
</style>